import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  ORDER_INVOICE_BLOCK_DATA_SOURCE,
  OrderInvoiceBlockDataSource,
} from './order-invoice-block-view-model';
import { OrderInvoiceBlockPreviewDataSource } from './order-invoice-block-preview-data-source';
import { OrderInvoiceBlockStoreDataSource } from './order-invoice-block-store-data-source';

export function provideOrderInvoiceBlockDataSource(): Provider[] {
  return [
    OrderInvoiceBlockStoreDataSource,
    OrderInvoiceBlockPreviewDataSource,
    {
      provide: ORDER_INVOICE_BLOCK_DATA_SOURCE,
      useFactory: (): OrderInvoiceBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(OrderInvoiceBlockPreviewDataSource)
          : inject(OrderInvoiceBlockStoreDataSource);
      },
    },
  ];
}
